import { queryOptions } from '@tanstack/react-query'
import type { ChildStatus, MessageSituation } from '@/contract'
import { partnerApi } from './api'

/* Spec PARTNER-001 — chaves e consultas do TanStack Query (todas sob ['partner', ...]). */

export type ChildFilters = { q?: string; status?: ChildStatus }
export type MessageFilters = { situation?: MessageSituation }

export const queryKeys = {
    all: ['partner'] as const,
    me: ['partner', 'me'] as const,
    organization: ['partner', 'organization'] as const,
    orgLookup: (code: string) => ['partner', 'org-lookup', code] as const,
    children: ['partner', 'children'] as const,
    childList: (filters: ChildFilters) => ['partner', 'children', 'list', filters] as const,
    child: (id: string) => ['partner', 'children', 'detail', id] as const,
    milestones: (id: string) => ['partner', 'children', 'milestones', id] as const,
    messages: ['partner', 'messages'] as const,
    messageList: (filters: MessageFilters) => ['partner', 'messages', 'list', filters] as const,
    conversation: (childId: string, sponsorId: string) => ['partner', 'children', 'conversation', childId, sponsorId] as const,
    pushConfig: ['partner', 'push', 'config'] as const,
    messageLocale: ['partner', 'me', 'message-locale'] as const,
    notifications: ['partner', 'me', 'notifications'] as const,
}

/* Sem repeticao: a guarda decide na hora (tela de falha tem "tentar de novo"). */
export const meQuery = queryOptions({ queryKey: queryKeys.me, queryFn: partnerApi.me, staleTime: 60_000, retry: false })

/* PARTNER-002: chave publica dos avisos (muda so com troca das variaveis no servidor). */
export const pushConfigQuery = queryOptions({ queryKey: queryKeys.pushConfig, queryFn: partnerApi.pushConfig, staleTime: Infinity })

/* PWA-020: idioma das mensagens da pessoa (e se a traducao esta ligada no servidor). */
export const messageLocaleQuery = queryOptions({ queryKey: queryKeys.messageLocale, queryFn: partnerApi.messageLocale, staleTime: 5 * 60_000 })

/* PARTNER-004: avisos por tipo da pessoa (valem em todos os aparelhos dela). */
export const notificationsQuery = queryOptions({ queryKey: queryKeys.notifications, queryFn: partnerApi.notifications })

export const organizationQuery =queryOptions({ queryKey: queryKeys.organization, queryFn: partnerApi.organization })

export const childrenQuery = (filters: ChildFilters) =>
    queryOptions({ queryKey: queryKeys.childList(filters), queryFn: () => partnerApi.children(filters) })

export const childQuery = (id: string) => queryOptions({ queryKey: queryKeys.child(id), queryFn: () => partnerApi.child(id) })

// Spec PARTNER-003: marcos da crianca (a situacao muda pela analise do ChildFund)
export const milestonesQuery = (childId: string) =>
    queryOptions({ queryKey: queryKeys.milestones(childId), queryFn: () => partnerApi.milestones(childId), refetchOnWindowFocus: true })


// Spec PWA-009: a OSP volta a lista ao trocar de aba (mensagens novas chegam pela moderacao do ChildFund)
export const messagesQuery = (filters: MessageFilters) =>
    queryOptions({ queryKey: queryKeys.messageList(filters), queryFn: () => partnerApi.messages(filters), refetchOnWindowFocus: true })

// Spec PWA-012: conversa da crianca com um padrinho (a situacao muda pela moderacao do ChildFund)
export const conversationQuery = (childId: string, sponsorId: string) =>
    queryOptions({ queryKey: queryKeys.conversation(childId, sponsorId), queryFn: () => partnerApi.conversation(childId, sponsorId), refetchOnWindowFocus: true })
